import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable()
export class ContactUsService {
    mailgunApiUrl: any;
    constructor(private httpClient: HttpClient) {

    }
    sendEmail(data) {
    return this.httpClient.post('/ContactUs',data);
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/contact-us.service.ts